import { render, staticRenderFns } from "./PopularExams.vue?vue&type=template&id=3f424540&"
import script from "./PopularExams.vue?vue&type=script&lang=js&"
export * from "./PopularExams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports